import { render, staticRenderFns } from "./cropper.vue?vue&type=template&id=12b45ce6&scoped=true&"
import script from "./cropper.vue?vue&type=script&lang=js&"
export * from "./cropper.vue?vue&type=script&lang=js&"
import style0 from "./cropper.vue?vue&type=style&index=0&id=12b45ce6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b45ce6",
  null
  
)

export default component.exports